module.exports = __webpack_public_path__ + "assets/img/Guide05.e4babf95.png";